export enum ErrorOrigin {
  INPUT = 'INPUT',
  API = 'API'
}

export type Errors = {
  [origin in ErrorOrigin]: Error[];
};

export type Error = {
  rule: string;
  field: string;
  message: string;
};

export const findErrorByField = (errors: Errors, field: string): Error | undefined => {
  const inputError = errors[ErrorOrigin.INPUT].find((error) => error.field === field);
  if (inputError) {
    return inputError;
  }

  const apiError = errors[ErrorOrigin.API].find((error) => error.field === field);
  if (apiError) {
    return apiError;
  }

  return undefined;
};

export const highlightErrorField = (errors: Errors, field: string): string => {
  return undefined !== findErrorByField(errors, field) ? ' text-danger' : '';
};
